import { GlButton, GlTooltipDirective } from '@gitlab/ui';
import { launchDrawioEditor } from '~/drawio/drawio_editor';
import { create } from '~/drawio/markdown_field_editor_facade';
export default {
    name: 'DrawioToolbarButton',
    components: {
        GlButton
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        uploadsPath: {
            type: String,
            required: true
        },
        markdownPreviewPath: {
            type: String,
            required: true
        }
    },
    methods: {
        getTextArea () {
            return document.querySelector('.js-gfm-input');
        },
        launchDrawioEditor () {
            launchDrawioEditor({
                editorFacade: create({
                    uploadsPath: this.uploadsPath,
                    textArea: this.getTextArea(),
                    markdownPreviewPath: this.markdownPreviewPath
                })
            });
        }
    }
};
